module.exports = __webpack_public_path__ + "static/img/paixu2.4963517.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/paixu2.png
// module id = e2sI
// module chunks = 5